import { computed, inject, Injectable, signal } from '@angular/core';
import { WishListService } from '../../shared/services/wish-list.service';
import { CatalogOptionResponse } from '../../shared/interfaces/catalog-option-response.interface';
import { combineLatest, Observable, of, switchMap, tap } from 'rxjs';
import { GetWishListDetailResponse } from '../../shared/interfaces/get-wish-list-detail-response.interface';

@Injectable({ providedIn: 'root' })
export class WishListDataService {
  private wishListService = inject(WishListService);

  private _wishListData = signal<CatalogOptionResponse[]>([]);
  private _wishListDetailData = signal<GetWishListDetailResponse[]>([]);
  private _wishListCounter = signal(0);
  private _hasWishListArticles = signal(false);

  wishListData = computed(() => this._wishListData());
  wishListDetailData = computed(() => this._wishListDetailData());
  wishListCounter = computed(() => this._wishListCounter());
  hasWishLists = computed(() => this._hasWishListArticles());

  private _sharedWishLists = signal<CatalogOptionResponse[]>([]);
  private _notSharedWishLists = signal<CatalogOptionResponse[]>([]);

  sharedWishLists = computed(() => this._sharedWishLists());
  notSharedWishLists = computed(() => this._notSharedWishLists());

  constructor() {
    this.getWishList();
  }

  getWishList() {
    this.wishListService
      .getWishList()
      .pipe(
        tap((wishLists) => {
          this._wishListCounter.set(wishLists.length);
          this._hasWishListArticles.set(wishLists.length > 0);
          this._wishListData.set(wishLists);

          const shared = wishLists.filter((w) => w.status);
          const notShared = wishLists.filter((w) => !w.status);

          this._sharedWishLists.set(shared);
          this._notSharedWishLists.set(notShared);
        }),
        switchMap((wishLists) => {
          const wishListDetailRequests: Observable<
            GetWishListDetailResponse[]
          >[] = [];

          wishLists.forEach((wL) => {
            const request = this.wishListService.getWishListDetail(wL.idValue);
            wishListDetailRequests.push(request);
          });

          return combineLatest(wishListDetailRequests);
        })
      )
      .subscribe({
        next: (response) => this._wishListDetailData.set(response.flat()),
      });
  }
}
